import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function swiperTeamMembers() {
    const selector = ".swiper-team-members";
    const element = document.querySelector(selector);
    if (!element) return;

    const slideCount = element.querySelectorAll('.swiper-slide').length;
    const maxSlidesPerView = 2; // Based on max breakpoint

    new Swiper(selector, {
        modules: [Navigation, Pagination],
        slidesPerView: 1.3,
        spaceBetween: 16,
        centeredSlides: false,
        loop: slideCount > maxSlidesPerView,
        speed: 600,

        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        breakpoints: {
            576: {
                slidesPerView: 1.5,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            992: {
                slidesPerView: 2, // "de dos en dos" as requested
                spaceBetween: 30,
            }
        }
    });
}
